import type { CancelablePromise } from '/src/api';
import { OpenAPI, request as __request } from '/src/api';
import { TBulkImportResponse } from '/src/lib/types';

export class BulkService {
  /**
   * List Bulks
   * @returns Bulk[]
   * @throws ApiError
   */
  public static async import(req: FormData): CancelablePromise<any> {
    const res = (await __request(OpenAPI, {
      method: 'POST',
      url: '/import',
      body: req,
    })) as TBulkImportResponse;

    return res;
  }
}
